import { isTemplate } from '@flow/libs/agreement';
import useAgreement from '@app/hooks/use-agreement';

import EditingInternalApproversToggle from '@app/components/document-tabs/settings-tab/sections/default-settings/toggles';
import AgreementVideo from '@app/components/agreement-video';
import CollaborationSettings from '@app/components/document-tabs/settings-tab/sections/default-settings/collaboration-settings';
import DefaultFolder from '@app/components/document-tabs/settings-tab/sections/default-settings/folder-content/folder';
import Divider from '@app/components/divider';
import SectionSeparator from '@app/components/document-tabs/settings-tab/components/section-separator/section-separator';
import { InfoBox } from '@app/components/info-box';
import { T } from '@app/components/translation';

import CreatorRole from './fields/creator-role';
import style from './default-settings.module.scss';

export type Props = {
  agreementId: number;
};

const DefaultSettings = ({ agreementId }: Props) => {
  const agreement: Oneflow.Agreement = useAgreement(agreementId);

  return (
    <div className={style.DefaultSettings}>
      {/* TODO: This is a temp information, will get removed once user get adopted to the change */}
      <InfoBox
        headerText={
          <T
            _str="“Display language” has moved"
            _comment="Header text for info box in General settings, to inform users about the change."
          />
        }
        bodyText={
          <T
            _str="It’s now called “Language” under Counterparty preferences."
            _comment="Description text for info box in General settings, to inform users about the change. in language selector."
          />
        }
      />
      {isTemplate(agreement) && (
        <>
          <CreatorRole agreementId={agreementId} />
          <SectionSeparator />
          <DefaultFolder agreementId={agreementId} />
          <SectionSeparator />
        </>
      )}
      <AgreementVideo agreementId={agreementId} />
      <CollaborationSettings agreementId={agreementId} />
      <Divider
        solid
        className={style.Divider}
      />
      <EditingInternalApproversToggle agreementId={agreementId} />
    </div>
  );
};

export default DefaultSettings;
